<template>
  <div class="flex flex-col gap-y-2">
    <label class="w-full flex flex-col gap-0.5">
      <div v-if="label" :class="labelClass" class="flex w-1/2 items-center">
        {{ label }} <span v-if="isRequired" class="text-brand-red">*</span>
      </div>
    </label>
    <div v-if="showPartCountSelector" class="flex gap-x-3">
      <Field :value="1" name="selectFileType" type="radio" v-slot="{ field }">
        <label class="flex gap-x-2">
          <input
            class="accent-primary"
            type="radio"
            v-bind="field"
            @change="fileValidityStore.resetFileTypeFields(resetField)"
          />
          {{ $t('fourPartFileType') }}
        </label>
      </Field>
      <Field :value="2" name="selectFileType" type="radio" v-slot="{ field }">
        <label class="flex gap-x-2">
          <input
            class="accent-primary"
            type="radio"
            v-bind="field"
            @change="fileValidityStore.resetFileTypeFields(resetField)"
          />
          {{ $t('threePartFileType') }}
        </label>
      </Field>
    </div>
    <div class="flex flex-col items-top md:flex-row">
      <div class="flex items-start gap-x-2">
        <Field
          :rules="isRequiredRule"
          name="departmentCode"
          class="w-full flex flex-col gap-y-1"
          v-slot="{ field, errors: errs }"
        >
          <SimpleTextInput
            :field="field"
            :errors="errs"
            :placeholder="$t('department')"
            class="flex-1"
            mask="###"
          />
        </Field>
        <div class="px-2 pt-1.5">/</div>
      </div>
      <div class="flex items-start gap-x-2">
        <Field
          :rules="isRequiredRule"
          name="serviceYear"
          class="w-full flex flex-col gap-y-1"
          v-slot="{ field, errors: errs }"
        >
          <SimpleTextInput
            :field="field"
            :errors="errs"
            :placeholder="$t('year')"
            mask="####"
            class="flex-1"
          />
        </Field>
        <div class="px-2 pt-1.5">/</div>
      </div>
      <!-- if showPartCountSelector is false, display by default
            but if it's enabled, rely on selectFileType on the visibility of this element
      -->
      <div
        v-if="!showPartCountSelector || (showPartCountSelector && values.selectFileType === 1)"
        class="flex items-start gap-x-2"
      >
        <Field
          :rules="isRequiredRule"
          name="serviceCode"
          class="flex flex-col gap-y-1"
          v-slot="{ field, errors: errs }"
        >
          <SimpleTextInput
            :field="field"
            :errors="errs"
            :placeholder="$t('type')"
            mask="###"
            class="flex-1"
          />
        </Field>
        <div class="px-2 pt-1.5">/</div>
      </div>
      <div class="flex items-start gap-x-2">
        <Field
          :rules="isRequiredRule"
          name="sequenceNumber"
          class="flex flex-col gap-y-1"
          v-slot="{ field, errors: errs }"
        >
          <SimpleTextInput
            :field="field"
            :errors="errs"
            :placeholder="$t('sequence')"
            :max-length="11"
            class="flex-1"
          />
        </Field>
        <div class="px-2 pt-1.5 text-transparent">/</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import SimpleTextInput from '@/components/SimpleForm/TextInput.vue'
import { useFileValidityStore } from '@/stores/file_validity'
import { Field } from 'vee-validate'

defineProps({
  showPartCountSelector: Boolean,
  label: String,
  labelClass: String,
  isRequired: {
    type: Boolean,
    default: () => true
  },
  values: {
    type: Object
  },
  resetField: {
    type: Function
  },
  setFieldValue: {
    type: Function
  },
  showLabels: {
    type: Boolean,
    default: () => true
  }
})

const fileValidityStore = useFileValidityStore()

function isRequiredRule(value) {
  if (value && `${value}`.trim()) {
    return true
  }

  return 'INVALID_REQUIRED'
}

function onChange(handleChange, value) {
  handleChange(value)
}
</script>

<style lang="scss" scoped></style>
